import Grid from '@highcharts/grid-lite/es-modules/masters/grid-lite.src.js';
import { getSMSizes } from "./data";

const columns = {
    city: "Miasto",
    budget: "Budżet",
    budgetPerCitizen: "Budżet na<br>mieszkańca",
    guards: "Liczba<br>strażników",
    guardsPer100k: "Strażników na<br>100k mieszkańców",
}

/**
 * @param {string} id
 */
export default function gridBudget(id) {
    if (!document.getElementById(id)) return;

    const smData = getSMSizes()

    Grid.grid(id, {
        dataTable: {
            columns: {
                [columns.city]: smData.map(e => e.city),
                [columns.budget]: smData.map(e => e["Budżet"]),
                [columns.budgetPerCitizen]: smData.map(e => e.budgetPerCitizen),
                [columns.guards]: smData.map(e => e["Etaty: liczba strażników"]),
                [columns.guardsPer100k]: smData.map(e => e.guardsPer100k),
            }
        },
        rendering: {
            rows: {
                strictHeights: false
            },
            theme: 'hcg-theme-default theme-compact'
        },
        columns: [{
            id: "Miasto",
            cells: {
                className: 'bold'
            }
        }, {
            id: columns.budget,
            cells: {
                format: '{(divide value 1000000):.1f} mln zł'
            }
        }, {
            id: "Budżet na<br>mieszkańca",
            cells: {
                format: '{(value):.0f} zł'
            }
        }, {
            id: "Liczba<br>strażników",
            cells: {
                format: '{(value):.0f}'
            }
        }, {
            id: "Strażników na<br>100k mieszkańców",
            cells: {
                format: '{(value):.1f}'
            }
        }]
    });


}
